export const LANGUAGE_OPTIONS = [
  {
    code: "zh_cn",
    label: "简中",
    short: "ZH",
    fullLabel: "简体中文",
    appLang: "zh_cn",
    copyLang: "zh_cn",
  },
  {
    code: "yn_yu",
    label: "VI",
    short: "VI",
    fullLabel: "Tiếng Việt",
    appLang: "yn_yu",
    copyLang: "yn_yu",
  },
  {
    code: "en_us",
    label: "EN",
    short: "EN",
    fullLabel: "English",
    appLang: "en_us",
    copyLang: "en_us",
  },
  {
    code: "es_spa",
    label: "ES",
    short: "ES",
    fullLabel: "Español",
    appLang: "es_spa",
    copyLang: "es_spa",
  },
  {
    code: "ms_my",
    label: "MY",
    short: "MY",
    fullLabel: "Bahasa Melayu",
    appLang: "ms_my",
    copyLang: "ms_my",
  },
  {
    code: "idn_yu",
    label: "ID",
    short: "ID",
    fullLabel: "Bahasa Indonesia",
    appLang: "idn_yu",
    copyLang: "idn_yu",
  },
  {
    code: "ko_hy",
    label: "KO",
    short: "KO",
    fullLabel: "한국어",
    appLang: "ko_hy",
    copyLang: "ko_hy",
  },
];

export const DEFAULT_LANGUAGE_OPTION =
  LANGUAGE_OPTIONS.find((item) => item.code === "en_us") || LANGUAGE_OPTIONS[0];

const LANGUAGE_ALIASES = {
  zh_hk: "zh_cn",
};

export function findLanguageOption(code) {
  const normalizedCode = LANGUAGE_ALIASES[code] || code;
  return (
    LANGUAGE_OPTIONS.find(
      (item) => item.code === normalizedCode || item.appLang === normalizedCode
    ) || null
  );
}

export function resolveLanguageOption(savedDisplayLang, savedLang) {
  return (
    findLanguageOption(savedDisplayLang) ||
    findLanguageOption(savedLang) ||
    DEFAULT_LANGUAGE_OPTION
  );
}
